import { Link } from 'react-router-dom';

const features = [
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20elegant%20lifestyle%20product%20photography%20with%20soft%20natural%20lightning%2C%20cream%20and%20terracotta%20tones%2C%20curated%20aesthetic%20items%20on%20a%20clean%20wooden%20surface%2C%20editorial%20style%2C%20harmonious%20composition%2C%20gentle%20shadows&width=800&height=600&seq=feature-xb-01&orientation=landscape',
    title: '精选材质 · 极致触感',
    desc: '性巴克甄选全球优质原料，通过严苛的品质把控体系，确保每件产品都拥有无与伦比的质感与耐用性。',
    tag: '品质',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20design%20studio%20workspace%20with%20warm%20amber%20lighting%2C%20creative%20artistic%20atmosphere%2C%20clean%20wooden%20desk%20with%20elegant%20objects%2C%20soft%20cream%20and%20golden%20hues%2C%20editorial%20interior%20photography&width=800&height=600&seq=feature-xb-02&orientation=landscape',
    title: '匠心设计 · 美学典范',
    desc: '汇聚国内外顶尖设计师，性巴克将艺术美学融入产品设计之中，让每件作品都成为值得珍藏的艺术品。',
    tag: '设计',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20lifestyle%20moment%20with%20natural%20light%2C%20person%20enjoying%20a%20peaceful%20morning%20with%20elegant%20objects%2C%20soft%20cream%20and%20terracotta%20color%20palette%2C%20minimalist%20aesthetic%2C%20editorial%20lifestyle%20photography&width=800&height=600&seq=feature-xb-03&orientation=landscape',
    title: '多元场景 · 随心搭配',
    desc: '无论是在家中独处、朋友聚会还是办公场景，性巴克的产品都能完美融入，为你的生活增添独特韵味。',
    tag: '场景',
  },
];

export default function FeatureSection() {
  return (
    <section className="relative py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label tracking-[0.15em] text-primary-500 uppercase mb-3">
            产品特色
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为什么选择
            <span className="text-primary-500">性巴克</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            性巴克以卓越的产品力与独特的品牌魅力，赢得万千用户的信赖与青睐。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, i) => (
            <Link
              key={f.title}
              to="/categories"
              className="group block bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  title={`性巴克${f.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 px-3 py-1.5 bg-background-50/90 backdrop-blur-sm text-xs font-semibold text-primary-600 rounded-full">
                  {f.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                  {f.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {f.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}